
var IDTypes = [
  "Carta d'identità",
  "Carta d'identità elettronica",
  "Passaporto",
  "Patente"
]


export default IDTypes;